import { Controller } from "@hotwired/stimulus"

// data-controller="force-focus"
export default class extends Controller {
  static values = {
    selector: String,
    // 드롭다운 같은 예외 셀렉터 (원하면 추가 가능)
    ignoreSelector: { type: String, default: "select, option, [role='listbox'], [role='option']" }
  }

  connect() {
    this.onPointerDown = (e) => this.handlePointerDown(e)
    this.onFocusIn = (e) => this.handleFocusIn(e)
    this.onChange = (e) => this.handleChange(e)

    // ✅ 문서 전체를 막지 말고, 폼 영역(this.element)에서만 감시
    this.element.addEventListener("pointerdown", this.onPointerDown, true)
    this.element.addEventListener("focusin", this.onFocusIn, true)
    this.element.addEventListener("change", this.onChange, true)

    this.focus()
  }

  disconnect() {
    this.element.removeEventListener("pointerdown", this.onPointerDown, true)
    this.element.removeEventListener("focusin", this.onFocusIn, true)
    this.element.removeEventListener("change", this.onChange, true)
  }

  handlePointerDown(event) {
    // ✅ 드롭다운(또는 예외 영역) 클릭이면 포커스 강제 이동 금지
    if (event.target.closest(this.ignoreSelectorValue)) return
    // 클릭으로 포커스가 다른 데로 갈 때 다시 되돌리기
    this.focus()
  }

  handleFocusIn(event) {
    // ✅ 드롭다운에 포커스 들어오면 그대로 둠
    if (event.target.closest(this.ignoreSelectorValue)) return

    // 다른 요소로 포커스 갔을 때 다시 되돌리기
    const target = this.getTarget()
    if (target && event.target !== target) this.focus()
  }

  handleChange(event) {
    // ✅ 드롭다운 선택이 끝난 "후"에는 다시 검색 input에 포커스
    if (event.target.closest("select")) this.focus()
  }

  getTarget() {
    return document.querySelector(this.selectorValue)
  }

  focus() {
    requestAnimationFrame(() => {
      this.getTarget()?.focus({ preventScroll: true })
    })
  }
}